export default __webpack_public_path__ + "static/media/sold_out.c614caf7.png";